var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 10.3C6.2386 10.3002 7 11.0614 7 12.0002C6.99989 12.939 6.23853 13.7003 5.2998 13.7004C4.36099 13.7004 3.59971 12.939 3.59961 12.0002C3.59961 11.0614 4.36092 10.3 5.2998 10.3ZM12 10.3C12.9388 10.3002 13.7002 11.0614 13.7002 12.0002C13.7001 12.939 12.9387 13.7003 12 13.7004C11.0612 13.7004 10.2999 12.939 10.2998 12.0002C10.2998 11.0614 11.0611 10.3 12 10.3ZM18.6992 10.3C19.6381 10.3 20.3994 11.0614 20.3994 12.0002C20.3993 12.939 19.638 13.7004 18.6992 13.7004C17.7605 13.7003 17.0001 12.9389 17 12.0002C17 11.0615 17.7605 10.3002 18.6992 10.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontal);
export default __webpack_public_path__ + "static/media/dots-horizontal.16f3e8c87bd10118bc4fe4125586279a.svg";
export { ForwardRef as ReactComponent };